// extracted by mini-css-extract-plugin
module.exports = {"star-rating":"StarRatings_star-rating__3vgam","star-rating__projects":"StarRatings_star-rating__projects__EomdD"};